module.exports = __webpack_public_path__ + "static/media/privacy.135673ba.md";